import { ApolloClient, createHttpLink, InMemoryCache, from } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { onError } from "@apollo/client/link/error";
import { logout } from "./utils/authUtils";

const httpLink = createHttpLink({
  uri: process.env.REACT_APP_API_URL + "/graphql",
  // uri: "https://stag-api.nysais.org/graphql",
  credentials: 'include',
});
const authLink = setContext((_, { headers }) => {
  const token = localStorage.getItem("@authToken");
  return {
    headers: {
      ...headers,
      authorization: token ? token : "",
    },
  };
});

// Error link to handle authentication errors globally
const errorLink = onError(({ graphQLErrors, networkError, operation, forward }) => {
  // Skip authentication logout for public pages that must work without a logged-in session
  const isNonMemberSchoolPage = window.location.pathname.includes('/addnewschool');
  const isEventRegistrationPage = window.location.pathname.includes('/eventregistration');
  const isCreateOrderPage = window.location.pathname.includes('/createorder');
  const isUnsubscribePage = window.location.pathname.includes('/unsubscribe');
  const shouldSkipAuthLogout =
    isNonMemberSchoolPage ||
    isEventRegistrationPage ||
    isCreateOrderPage ||
    isUnsubscribePage;
  
  if (graphQLErrors) {
    graphQLErrors.forEach(({ message, locations, path }) => {
      console.log(
        `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
      );
      
      // Check for NYSAIS user trying to create orders error - this should always log out the user
      if (message.includes('Orders can only be created for school users, not NYSAIS users')||message.includes('Invalid user ID provided for orderCreatedFor')) {
        console.log('NYSAIS user trying to create order, logging out...');
        // Store error message to show after logout redirect
        localStorage.setItem('@logoutErrorMessage', message);
        logout();
        return;
      }
      
      // Check for authentication errors (but skip for public pages that don't require login)
      if (!shouldSkipAuthLogout && (message.includes('Not authenticated') || 
          message.includes('Unauthorized') || 
          message.includes('Authentication required') ||
          message.includes('Invalid token') ||
          message.includes('Token expired'))) {
        console.log('Authentication error detected, logging out...');
        logout();
      }
    });
  }

  if (networkError) {
    console.log(`[Network error]: ${networkError}`);
    
    // Check for 401 Unauthorized status (but skip for public pages that don't require login)
    if (!shouldSkipAuthLogout && networkError.statusCode === 401) {
      console.log('401 Unauthorized error detected, logging out...');
      logout();
    }
  }
});
// GraphQL Init
const client = new ApolloClient({
  link: from([errorLink, authLink, httpLink]),
  cache: new InMemoryCache(),
});
export default client;
